export const progressScroll = {
  data () {
    return {
      progress: document.getElementById('scrollArea') + '%'
    }
  },
  mounted () {
    const el = document.getElementById('scrollArea')
    if (el) el.addEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll () {
      const winScroll = document.getElementById('scrollArea').scrollTop
      const height = document.getElementById('scrollArea').scrollHeight - document.getElementById('scrollArea').clientHeight
      this.progress = (winScroll / height) * 100 + '%'
    }
  }
}
